// F2W product card — option + ATC handlers
(function () {
  if (document.documentElement.dataset.f2wAtcBound) return;
  document.documentElement.dataset.f2wAtcBound = '1';

  function f2wFormatPrice(cents) {
    if (window.Shopify && Shopify.formatMoney && window.f2w_money_format) {
      return Shopify.formatMoney(cents, window.f2w_money_format);
    }
    return (cents / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // Option button (size selector)
  document.addEventListener('click', function (e) {
    var optBtn = e.target.closest('.f2w-option-btn');
    if (!optBtn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var variantId = optBtn.dataset.variantId;
    var group = optBtn.closest('.f2w-option-group');
    if (group) {
      group.querySelectorAll('.f2w-option-btn').forEach(function (b) {
        b.removeAttribute('aria-selected');
        b.classList.remove('is-selected');
      });
      optBtn.setAttribute('aria-selected', 'true');
      optBtn.classList.add('is-selected');
    }
    var wrapper = optBtn.closest('.f2w-atc-wrapper');
    if (wrapper) {
      var atcBtn = wrapper.querySelector('.f2w-atc-btn');
      if (atcBtn && variantId) {
        atcBtn.dataset.variantId = variantId;
        atcBtn.disabled = optBtn.classList.contains('is-unavailable');
      }
      var card = wrapper.closest('product-card');
      if (card) {
        var variantsJson = card.querySelector('.f2w-variants-json');
        if (variantsJson) {
          try {
            var variants = JSON.parse(variantsJson.textContent);
            var variant = variants.find(function (v) { return String(v.id) === String(variantId); });
            if (variant && variant.price !== undefined) {
              var priceEl = card.querySelector('.price ins .amount') || card.querySelector('.price .amount');
              if (priceEl) priceEl.textContent = f2wFormatPrice(variant.price);
            }
          } catch (err) {
            console.warn('F2W price update error:', err);
          }
        }
      }
    }
  }, true);

  // ATC button
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.f2w-atc-btn[data-variant-id]');
    if (!btn || btn.disabled || btn.classList.contains('loading')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.classList.add('loading');
    btn.disabled = true;
    var resetTimer = setTimeout(function () {
      btn.classList.remove('loading');
      btn.disabled = false;
    }, 5000);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Cart add failed: ' + r.status);
      return r.json();
    })
    .then(function () {
      clearTimeout(resetTimer);
      btn.classList.remove('loading');
      btn.disabled = false;
      setTimeout(function () {
        if (window.opusRefresh) window.opusRefresh();
        if (window.opusOpen) {
          window.opusOpen();
        } else {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart-drawer:open', { bubbles: true })
          );
        }
      }, 150);
    })
    .catch(function (err) {
      clearTimeout(resetTimer);
      console.error('F2W ATC error:', err);
      btn.classList.remove('loading');
      btn.disabled = false;
    });
  }, true);

  // ── Init: correct price on load for pre-selected variant ─────────────────
  function initF2wCards() {
    document.querySelectorAll('.f2w-atc-wrapper').forEach(function (wrapper) {
      var selected = wrapper.querySelector('.f2w-option-btn.is-selected')
                  || wrapper.querySelector('.f2w-option-btn:not(.is-unavailable)');
      if (!selected) return;

      var variantId = parseInt(selected.dataset.variantId, 10);
      var jsonEl = wrapper.querySelector('.f2w-variants-json');
      if (!jsonEl) return;

      try {
        var variants = JSON.parse(jsonEl.textContent);
        var variant = variants.find(function (v) { return v.id === variantId; });
        if (!variant || variant.price === undefined) return;

        var card = wrapper.closest('product-card');
        var priceEl = card && (card.querySelector('.price ins .amount') || card.querySelector('.price .amount'));
        if (!priceEl) return;

        priceEl.textContent = f2wFormatPrice(variant.price);
      } catch (err) {
        console.warn('F2W init price error:', err);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initF2wCards();
      setTimeout(initF2wCards, 500);
    });
  } else {
    initF2wCards();
    setTimeout(initF2wCards, 500);
  }

})();

// CPG (custom product grid) — option + ATC handlers
(function () {
  if (!document.documentElement.dataset.cpgOptionBound) {
    document.documentElement.dataset.cpgOptionBound = 'true';
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cib__variant-btn');
      if (!btn) return;
      var card = btn.closest('.custom-product-grid__card');
      if (!card) return;
      card.querySelectorAll('.cib__variant-btn').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      var atcBtn = card.querySelector('.cib__atc-btn');
      if (atcBtn) atcBtn.dataset.variantId = btn.dataset.variantId;
      var priceEl = card.querySelector('.custom-product-grid__price');
      if (priceEl && btn.dataset.variantId) {
        fetch('/variants/' + btn.dataset.variantId + '.js')
          .then(function (r) { return r.json(); })
          .then(function (v) {
            if (v.price !== undefined) {
              priceEl.innerHTML = window.Shopify && Shopify.formatMoney && window.f2w_money_format
                ? Shopify.formatMoney(v.price, window.f2w_money_format)
                : (v.price / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
          });
      }
    });
  }

  if (!document.documentElement.dataset.cpgAtcBound) {
    document.documentElement.dataset.cpgAtcBound = 'true';
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cib__atc-btn');
      if (!btn || !btn.dataset.variantId) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var variantId = btn.dataset.variantId;
      var originalText = btn.textContent.trim();
      btn.disabled = true;
      btn.textContent = '...';
      var resetTimer = setTimeout(function () { btn.disabled = false; btn.textContent = originalText; }, 5000);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        clearTimeout(resetTimer);
        btn.disabled = false;
        btn.textContent = originalText;
        setTimeout(function () {
          if (window.opusRefresh) window.opusRefresh();
          if (window.opusOpen) window.opusOpen();
          else document.documentElement.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
        }, 150);
      })
      .catch(function () { clearTimeout(resetTimer); btn.disabled = false; btn.textContent = originalText; });
    }, true);
  }
})();

// CIB (collection-info / faq-item / gear-type-info) — option + ATC + price handlers
(function () {
  if (document.documentElement.dataset.cibOptionBound) return;
  document.documentElement.dataset.cibOptionBound = '1';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cib__variant-btn');
    if (!btn) return;
    var card = btn.closest('.cib__ref-card');
    if (!card) return;
    card.querySelectorAll('.cib__variant-btn').forEach(function (b) { b.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    var atcBtn = card.querySelector('.cib__atc-btn');
    if (atcBtn) atcBtn.dataset.variantId = btn.dataset.variantId;
    var priceEl = card.querySelector('.cib__ref-card__price');
    if (priceEl && btn.dataset.variantId) {
      fetch('/variants/' + btn.dataset.variantId + '.js')
        .then(function (r) { return r.json(); })
        .then(function (v) {
          if (v.price !== undefined) {
            priceEl.innerHTML = window.Shopify && Shopify.formatMoney && window.f2w_money_format
              ? Shopify.formatMoney(v.price, window.f2w_money_format)
              : (v.price / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          }
        });
    }
  });

  if (!document.documentElement.dataset.cibAtcBound) {
    document.documentElement.dataset.cibAtcBound = '1';
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cib__atc-btn[data-variant-id]');
      if (!btn || btn.disabled || btn.tagName === 'A') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      var originalText = btn.textContent.trim();
      btn.disabled = true;
      btn.textContent = '...';
      var resetTimer = setTimeout(function () { btn.disabled = false; btn.textContent = originalText; }, 5000);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        clearTimeout(resetTimer);
        btn.disabled = false;
        btn.textContent = originalText;
        setTimeout(function () {
          if (window.opusRefresh) window.opusRefresh();
          if (window.opusOpen) window.opusOpen();
          else document.documentElement.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
        }, 150);
      })
      .catch(function () { clearTimeout(resetTimer); btn.disabled = false; btn.textContent = originalText; });
    }, true);
  }
})();// CIB slider arrows
document.querySelectorAll('.cib__slider-wrapper').forEach(function (wrapper) {
  var track = wrapper.querySelector('.cib__ref-cards--slider');
  var prev = wrapper.querySelector('.f2w-arrow--prev');
  var next = wrapper.querySelector('.f2w-arrow--next');
  if (!track || !prev || !next) return;
  function updateArrows() {
    var noScroll = track.scrollWidth <= track.clientWidth + 4;
    var atStart  = noScroll || track.scrollLeft <= 4;
    var atEnd    = noScroll || track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    prev.classList.toggle('f2w-arrow--hidden', atStart);
    next.classList.toggle('f2w-arrow--hidden', atEnd);
  }
  var cardWidth = function () {
    var card = track.querySelector('.cib__ref-card');
    return card ? card.offsetWidth + 10 : 200;
  };
  prev.addEventListener('click', function () { track.scrollBy({ left: -cardWidth() * 3, behavior: 'smooth' }); });
  next.addEventListener('click', function () { track.scrollBy({ left: cardWidth() * 3, behavior: 'smooth' }); });
  track.addEventListener('scroll', updateArrows);
  updateArrows();
});

// Beste-koop nav slider arrows
document.querySelectorAll('.f2w-article-nav-slider').forEach(function(wrapper) {
  var track = wrapper.querySelector('.f2w-blog-slider__track');
  var prev  = wrapper.querySelector('.f2w-arrow--prev');
  var next  = wrapper.querySelector('.f2w-arrow--next');
  if (!track || !prev || !next) return;
  function updateArrows() {
    var noScroll = track.scrollWidth <= track.clientWidth + 4;
    prev.classList.toggle('f2w-arrow--hidden', noScroll || track.scrollLeft <= 4);
    next.classList.toggle('f2w-arrow--hidden', noScroll || track.scrollLeft + track.clientWidth >= track.scrollWidth - 4);
  }
  var cardW = function() { var c = track.querySelector('.f2w-blog-slider__card'); return c ? c.offsetWidth + 12 : 220; };
  prev.addEventListener('click', function() { track.scrollBy({ left: -cardW() * 2, behavior: 'smooth' }); });
  next.addEventListener('click', function() { track.scrollBy({ left:  cardW() * 2, behavior: 'smooth' }); });
  track.addEventListener('scroll', updateArrows);
  updateArrows();
});

// F2W Gallery slider arrows
document.querySelectorAll('.f2w-gallery__slider-wrap').forEach(function (wrap) {
  var track = wrap.querySelector('.f2w-gallery__list');
  var prev  = wrap.querySelector('.custom-product-grid__arrow--prev');
  var next  = wrap.querySelector('.custom-product-grid__arrow--next');
  if (!track || !prev || !next) return;
  function updateArrows() {
    var noScroll = track.scrollWidth <= track.clientWidth + 4;
    var atStart  = noScroll || track.scrollLeft <= 4;
    var atEnd    = noScroll || track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    prev.classList.toggle('f2w-arrow--hidden', atStart);
    next.classList.toggle('f2w-arrow--hidden', atEnd);
  }
  var cardWidth = function () {
    var c = track.querySelector('.f2w-gallery__item');
    return c ? c.offsetWidth + 12 : 260;
  };
  prev.addEventListener('click', function () { track.scrollBy({ left: -cardWidth() * 2, behavior: 'smooth' }); });
  next.addEventListener('click', function () { track.scrollBy({ left:  cardWidth() * 2, behavior: 'smooth' }); });
  track.addEventListener('scroll', updateArrows);
  updateArrows();
});

// F2W Brand block slider arrows
document.querySelectorAll('.f2w-blog-slider__wrapper').forEach(function (wrapper) {
  var track = wrapper.querySelector('.scb-slider__track');
  var prev  = wrapper.querySelector('.f2w-arrow--prev');
  var next  = wrapper.querySelector('.f2w-arrow--next');
  if (!track || !prev || !next) return;
  function updateArrows() {
    var noScroll = track.scrollWidth <= track.clientWidth + 4;
    prev.classList.toggle('f2w-arrow--hidden', noScroll || track.scrollLeft <= 4);
    next.classList.toggle('f2w-arrow--hidden', noScroll || track.scrollLeft + track.clientWidth >= track.scrollWidth - 4);
  }
  var cardW = function () {
    var c = track.querySelector('.scb-card');
    return c ? c.offsetWidth + 10 : 170;
  };
  prev.addEventListener('click', function () { track.scrollBy({ left: -cardW(), behavior: 'smooth' }); });
  next.addEventListener('click', function () { track.scrollBy({ left:  cardW(), behavior: 'smooth' }); });
  track.addEventListener('scroll', updateArrows);
  updateArrows();
});


// CPG article grid slider arrows
document.querySelectorAll('.custom-product-grid__slider-wrap').forEach(function (wrapper) {
  var track = wrapper.querySelector('.custom-product-grid__list');
  var prev  = wrapper.querySelector('.custom-product-grid__arrow--prev');
  var next  = wrapper.querySelector('.custom-product-grid__arrow--next');
  if (!track || !prev || !next) return;
  function updateArrows() {
    var noScroll = track.scrollWidth <= track.clientWidth + 4;
    prev.classList.toggle('f2w-arrow--hidden', noScroll || track.scrollLeft <= 4);
    next.classList.toggle('f2w-arrow--hidden', noScroll || track.scrollLeft + track.clientWidth >= track.scrollWidth - 4);
  }
  var cardW = function () {
    var c = track.querySelector('.custom-product-grid__item');
    return c ? c.offsetWidth + 10 : 200;
  };
  prev.addEventListener('click', function () { track.scrollBy({ left: -cardW() * 3, behavior: 'smooth' }); });
  next.addEventListener('click', function () { track.scrollBy({ left:  cardW() * 3, behavior: 'smooth' }); });
  track.addEventListener('scroll', updateArrows);
  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(updateArrows).observe(track);
  }
  updateArrows();
});
